export default {
  trigger: "提示框触发类型",
  show: "是否显示提示框",
  backgroundColor: "提示框背景色",
  extraCssText: "额外附加的样式",
  "textStyle.color": "文字颜色",
  "textStyle.fontFamily": "文字字体",
  "textStyle.tooltipFontSize": "文字大小",
  "textStyle.tooltipFontWeight": "文字字重",
  "axisPointer.type": "指示器类型",
  borderWidth: "提示框边框宽"
}
